const KEYWORD_CONNECTED_CHAR_REGEX = /[\p{L}\p{N}_'’]/u;

export const KEYWORD_BOUNDARY_CLASS = "[^\\p{L}\\p{N}_'’]";

export function isWholeKeywordMatch(text: string, start: number, end: number): boolean {
  const before = start > 0 ? text[start - 1] ?? "" : "";
  const after = end < text.length ? text[end] ?? "" : "";
  return isBoundary(before) && isBoundary(after);
}

function isBoundary(char: string): boolean {
  return char.length === 0 || !KEYWORD_CONNECTED_CHAR_REGEX.test(char);
}
